import React, { Component } from "react"

import { env, closed } from "../constants"

import { Card } from "../components"


class Joker extends Component {
    constructor() {
        super()
        this.state = {

        }
    }

    /* Card Open Status */
    openStatus = () => {

        const { joker } = this.props

        if (joker && joker.doc) {
            return "closed"
        }

        return "open"
    }

    render = () => {

        const { joker, solution } = this.props

        return (
            <div className="j-block" style={{ opacity: solution === "FOLD" ? 0.5 : 1 }}>
                {joker ?
                    <div className="j-card">
                        <div className={`j-flip-card ${this.openStatus()}`}>
                            <div className="j-flip-card-inner">
                                <div className="j-flip-card-front">
                                    <img src={closed.joker} alt="Closed" />
                                </div>
                                <div className="j-flip-card-back">
                                    <div>
                                        <Card data={joker.name} player={true} />
                                        {joker.dealer && <div className="player-card-additional">DOC</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p className="j-name">JOKER</p>
                    </div>
                    : <div className="j-card-exp" />
                }
                <div className="j-space">
                    <img src={`${env.endpoint}/images/joker.png`} alt="joker" />
                </div>

            </div>
        )
    }

}

export default Joker